var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      staticClass: "ml-10 auth-code_btn",
      attrs: { disabled: _vm.authCountdown },
      on: {
        click: function ($event) {
          return _vm.$emit("authCode")
        },
      },
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm.authCountdown ? _vm.authCountTime + "秒后重试" : "获取验证码"
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }